export default __webpack_public_path__ + "static/media/market yellow.196d108d.svg";